/*
import { useHistory } from "react-router-dom";
export const history = useHistory();
*/

//import createBrowserHistory from 'history/createBrowserHistory';

import { createBrowserHistory } from 'history'
export const history = createBrowserHistory()
